/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Extra_Point_1_LabelInputs */

const en_visa_e2_extra_point_1_label = /** @type {(inputs: Visa_E2_Extra_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Commercial Activity`)
};

const pt_visa_e2_extra_point_1_label = /** @type {(inputs: Visa_E2_Extra_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade Comercial Ativa`)
};

const es_visa_e2_extra_point_1_label = /** @type {(inputs: Visa_E2_Extra_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad Comercial Activa`)
};

/**
* | output |
* | --- |
* | "Active Commercial Activity" |
*
* @param {Visa_E2_Extra_Point_1_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_extra_point_1_label = /** @type {((inputs?: Visa_E2_Extra_Point_1_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Extra_Point_1_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_extra_point_1_label(inputs)
	if (locale === "es") return es_visa_e2_extra_point_1_label(inputs)
	return en_visa_e2_extra_point_1_label(inputs)
});